import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BikeRentService } from 'app/shared/services/bike-rent.service';
import { FileUploadComponent } from '../../../file-upload/file-upload.component';
import { FileUploadService } from 'app/shared/services/file-upload.service';
import { VehicleRegisterService } from 'app/shared/services/vehicle-register.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { CustomerService} from 'app/shared/services/customer.service';
import { AuthService } from 'app/shared/services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import { NbThemeService } from '@nebular/theme';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import { map, startWith, isEmpty} from 'rxjs/operators';
import { Observable} from 'rxjs';
import * as moment from 'moment';

@Component({
  selector: 'ngx-bike-rent',
  templateUrl: './bike-rent.component.html',
  styleUrls: ['./bike-rent.component.scss']
})
export class BikeRentComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>
  defaultDate : Date = new Date();

  dataList =[];

  filteredCustomerList: Observable<any[]>;
  customerList : any[];

  isDark: boolean = false;
  isShowAttachBtn: boolean=false;
  form: FormGroup;
  isSaveBtnDisabled : boolean= false;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };


   vehicleList : any[];
  
  
  validationMessages = {
    'rentId' : { 'required': 'This field is required' },
    'personName' : { 'required': 'This field is required' },
    'personId' : { 'required': 'This field is required' },
    'vehicleNo' : { 'required': 'This field is required' },
    'brand' : { 'required': 'This field is required' },
    'dateStart' : { 'required': 'This field is required' },
    'kmStart' : { 'required': 'This field is required' },
    'reason' : { 'required': 'This field is required' },
   
  
  };

  formErrors = {
  'rentId' : "",
  'personName' : "",
  'personId' : "",
  'vehicleNo' : "",
  'brand' : "",
  'dateStart' : "",
  'kmStart' : "",
  'reason' : "",

  };




    constructor(private fb: FormBuilder,
                private bikeRentService: BikeRentService,
                private vehicleRegisterService : VehicleRegisterService,
                private customerService : CustomerService,
                private fileUploadService:FileUploadService,
                private authService: AuthService,
                private toastr: ToastrService,
                private router : Router, 
                private themeService: NbThemeService,
                private dialogService: DialogService
              ) {
                this.datepickerConfig = Object.assign({},
                  {   
                    showWeekNumbers:false,
                    dateInputFormat : 'YYYY-MM-DD'
                  });
              }
              
               

              

  ngOnInit() {
    this.getAllVehicles();
    this.getCustomerList();

    this.form = this.fb.group({
      id : [null],
      rentId: ['',Validators.required],
      personName: ['',Validators.required],
      personId: ['',Validators.required],
      vehicleNo: ['',Validators.required],
      brand: ['',Validators.required],
      model: [''],
      color: [''],
      dateStart: ['',Validators.required],
      kmStart: ['',Validators.required],
      dateFinish: [''],
      kmFinish: [''],
      totalMiles: [''],
      reason: ['',Validators.required],
      income: [''],
      expense: [''],
      mainBillRef: [''],
      remarks: [''],


    });

    this.autoCompleteCustomer();
  
   this.form.valueChanges.subscribe((data) => {
    this.logValidationErrors(this.form);
  });


    this.getDataTableRowData();
   this.getControlPermissions();
    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });

  } /////// end onInit

  
  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='BR'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }




  attachFileButtonClick(){
    this.fileUploadService.refNo = this.form.value.guestId;
     const dialogConfig = new MatDialogConfig();
     dialogConfig.disableClose = true;
     dialogConfig.autoFocus = true;
     dialogConfig.width = "75%";
     this.dialogService.openDialog(FileUploadComponent,dialogConfig);
        
    }

  newButtonClick(): void {
    this.isShowAttachBtn=false; 
    this.isSaveBtnDisabled = false;
    this.form.reset();
    this.enableForm();
    this.getMaxId();
    
   }

   getAllVehicles(){
    this.vehicleRegisterService.getAll()
     .subscribe(
        (data) => {
                  this.vehicleList = data;
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                 });  
       
     }

     autoCompleteCustomer(){
      this.filteredCustomerList = this.form.get('personName').valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterCustomer(value))
      ); 
  }

  
  private _filterCustomer(cusName: string): any[] {
    if(cusName){
       const filterValue = cusName.toLowerCase();
       return this.customerList.filter(option => option.GuestName.toLowerCase().indexOf(filterValue) === 0);
    }
  }



getCustomerDetails(){      
  var filteredData;
  var cusName = this.form.value.personName;
  if(cusName){
  filteredData = this.customerList.filter(data =>data.GuestName.toLowerCase()===cusName.toLowerCase());
   if(filteredData.length ===1){
     this.form.patchValue({
       personId : filteredData[0].GuestId,
     });
   }else{
    this.form.patchValue({
      personId : null,
    });
   }
  }
}
     

  getCustomerList(){
  this.customerService.getAll()
   .subscribe(
      (data) => {
                this.customerList = data.filter((el)=>{
                  return el.Status !=="Deactivated";
                });             
                },
     (err) => 
              {
                if(err instanceof HttpErrorResponse){                 
                  if(err.status == 401){
                    this.router.navigate(['/login']);
                  }
                }
                console.log(err);
              });  
     
   }
  
   getMaxId(){
    var customerId = 0;
    var sCustomerId : String;
  
    this.bikeRentService.getMaxId()
    .subscribe(
      (res) => {
                  customerId = Number(res[0].MaxId) + 1;
                  sCustomerId = customerId.toString().padStart(5,'0');
                  this.form.patchValue({
                    rentId : "BR" + sCustomerId
                  });
                  

                },        
      (err) =>  {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                }, 
      )



   }

   getVehicleData(event){
    if(event.selectedIndex===0){
      this.form.patchValue({
        brand: null,
        model:null,
        color:null,
      });
    }else{
    this.form.patchValue({
      brand: this.vehicleList[event.selectedIndex-1].Brand,
      model:this.vehicleList[event.selectedIndex-1].Model,
      color:this.vehicleList[event.selectedIndex-1].Color,
    });

    }
   }

  isNumeric(value){
    if(!isNaN(value) &&  !isNaN(parseFloat(value))){
      return true;
    } 
     return false;
  
  }



   calculateAmounts(){
    let totalMiles =null;

    if(this.form.value.kmStart && 
      this.isNumeric(this.form.value.kmStart) && 
      this.form.value.kmFinish && 
      this.isNumeric(this.form.value.kmFinish)){

        totalMiles = (this.form.value.kmFinish - this.form.value.kmStart).toFixed(2);

    }

  
    this.form.patchValue({
      totalMiles :  totalMiles,
    });

   }

  saveButtonClick(): void {
    var data : any;
    
    this.logValidationErrors(this.form,true);
    const formData = this.mapFormValuesToCustomerModel();  

          if(this.isFilledFromFields()){
            
              if(!this.form.value.id){
                this.showProcessingIndicator = true;
                this.bikeRentService.create(formData)
                .subscribe(
                  (res) => {

                              if(res.success === 0){
                                this.form.patchValue({
                                rentId : res.autoId
                                });
                              this.saveButtonClick();
                              this.showProcessingIndicator = false; 
                              
                              }else if(res.success === 1){
                                data=res;
                                this.toastr.success('Record added successfully','Success'); 
                                this.showProcessingIndicator = false; 
                                this.isShowAttachBtn = true;
                                this.newButtonClick()
                             }   

                            },        
                  (err) =>  {
                              this.toastr.error('Failed to add record','Failure');                            
                              this.showProcessingIndicator = false;
                              if(err instanceof HttpErrorResponse){                 
                                if(err.status == 401){
                                  this.router.navigate(['/login']);
                                }
                              }
                              console.log(err);
                            }, 
                  )
  
                   

            }else{
            this.dialogService.openConfirmDialog('Are you sure you want to update this record?')
            .afterClosed().subscribe(res =>{
              if(res){
              this.showProcessingIndicator = true;
              this.bikeRentService.update(formData)
            .subscribe(
              (res) => {
                          this.toastr.success('Record updated successfully','Success');    
                          this.showProcessingIndicator = false;  
                          this.newButtonClick();
                        },        
              (err) =>  {
                          this.toastr.error('Failed to update record','Failure');
                          this.showProcessingIndicator = false;
                          if(err instanceof HttpErrorResponse){                 
                            if(err.status == 401){
                              this.router.navigate(['/login']);
                            }
                          }
                          console.log(err);
                        }, 
                      )

          }else{
            this.showProcessingIndicator = false;
          }
            })

        }

      }
      else{
        this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
        this.showProcessingIndicator = false;
        
      } 
                       
         
   }

  

   enableForm():void{
    Object.keys(this.form.controls).forEach(key => {
      this.form.controls[key].enable();
      //console.log(key)
    });
  }


  disableForm():void{
    Object.keys(this.form.controls).forEach(key => {
      this.form.controls[key].disable();   
    });
  }


  
  logValidationErrors(group: FormGroup = this.form,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if(isDirty)
      {
        this.enableForm();
        this.form.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }


  isFilledFromFields() : boolean {
    var value = this.form.value.personId;
    if(!value){
      this.form.patchValue({ personId :  null,personName :  null });    
    }

    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
          return false;
        }
        return true;
}

  mapFormValuesToCustomerModel(){
    let formData ={
      ...this.form.value,
      dateStart : moment(this.form.value.dateStart).format("YYYY-MM-DD"),
      dateFinish : moment(this.form.value.dateFinish).format("YYYY-MM-DD"),
      createdBy : this.authService.getUserLoggedIn(),
    }

    return formData;
    
  }
   



viewData(data){

  this.form.patchValue({
    id : data.Id,
    rentId:data.RentId,
    personName:data.PersonName,
    personId:data.PersonId,
    vehicleNo:data.VehicleNo,
    brand:data.Brand,
    model:data.Model,
    color:data.Color,
    dateStart:data.DateStart ?  moment(data.DateStart).format("YYYY-MM-DD"): null,
    kmStart:data.KmStart,
    dateFinish:data.DateFinish ?  moment(data.DateFinish).format("YYYY-MM-DD"): null,
    kmFinish:data.KmFinish,
    totalMiles:data.TotalMiles,
    reason:data.Reason,
    income:data.Income,
    expense:data.Expense,
    mainBillRef:data.MainBillRef,
    remarks:data.Remarks,
   
  })

  this.isShowAttachBtn = true; 
}

getDataTableRowData(){
  var data  = this.bikeRentService.dataRow;
  if(data){
    this.viewData(data);
  }
  else{
    this.newButtonClick()
  }
  
                       
}

}//end class


